/** @jsxImportSource @emotion/react */
import Layout from "components/Layout"
import { Box, Typography, Divider, Container } from "@mui/material"
import { PrivacyPolicyPageStyle } from "appearance"

const PrivacyPolicyPage = () => {
  const html = `<div class=WordSection1>
  <style>
  <!--
   /* Style Definitions */
   p.MsoNormal, li.MsoNormal, div.MsoNormal
    {margin:0in;
    font-size:12.0pt;
    font-family:Poppins,Roboto;
    color:white;
    border:none;}
  p.MsoTitle, li.MsoTitle, div.MsoTitle
    {margin-top:0in;
    margin-right:0in;
    margin-bottom:12.0pt;
    margin-left:0in;
    text-align:center;
    page-break-after:avoid;
    font-size:12.0pt;
    font-family:Poppins,Roboto;
    color:white;
    text-transform:uppercase;
    border:none;
    font-weight:bold;}
  p.MsoBodyText, li.MsoBodyText, div.MsoBodyText
    {margin-top:0in;
    margin-right:0in;
    margin-bottom:12.0pt;
    margin-left:0in;
    text-align:justify;
    font-size:12.0pt;
    font-family:Poppins,Roboto;
    color:white;
    border:none;}
  p.MsoBodyTextFirstIndent, li.MsoBodyTextFirstIndent, div.MsoBodyTextFirstIndent
    {margin-top:0in;
    margin-right:0in;
    margin-bottom:12.0pt;
    margin-left:0in;
    text-align:justify;
    text-indent:.5in;
    font-size:12.0pt;
    font-family:Poppins,Roboto;
    color:white;
    border:none;}
  span.Hyperlink0
    {mso-style-name:"Hyperlink\.0";
    color:blue;
    text-decoration:underline;}
  .MsoChpDefault
    {font-size:10.0pt;
    border:none;}
   /* Page Definitions */
   @page WordSection1
    {size:8.5in 11.0in;
    margin:1.0in 1.0in 1.0in 1.0in;}
  div.WordSection1
    {page:WordSection1;}
   /* List Definitions */
   ol
    {margin-bottom:0in;}
  ul
    {margin-bottom:0in;}
  -->
  </style>

  <p class=MsoTitle>Website Terms of Use</p>
  
  <p class=MsoBodyText><a name=main><b><u>Acceptance of Terms of Use</u></b></a></p>
  
  <p class=MsoBodyTextFirstIndent>These Terms of Use are entered into by and
  between you and Fan Space, LLC d/b/a Tribly (&quot;<b>Company</b>&quot;, &quot;<b>we</b>&quot;
  or &quot;<b>us</b>&quot;). The following terms and conditions (these &quot;<b>Terms
  of Use</b>&quot;), govern your access to and use of [<a
  href="http://www.triblymusic.com/"><span class=Hyperlink0><span
  style='color:white'><span style='color:white'>www.triblymusic.com</span></span></span></a>],
  including any content, functionality and services offered on or through [<a
  href="http://www.triblymusic.com/"><span class=Hyperlink0><span
  style='color:white'><span style='color:white'>www.triblymusic.com</span></span></span></a>]
  (the &quot;<b>Website</b>&quot;), whether as a guest or a registered user.</p>
  
  <p class=MsoBodyTextFirstIndent>Please read these Terms of Use carefully before
  you start to use the Website. <b>By using the Website or by clicking to accept
  or agree to the Terms of Use when this option is made available to you, you
  accept and agree to be bound and abide by these Terms of Use and our Privacy
  Policy, which is found at [https://store.triblymusic.com/privacy-policy) and is
  incorporated herein by reference</b>. If you do not want to agree to these
  Terms of Use or the Privacy Policy, you must not access or use the Website. </p>
  
  <p class=MsoBodyTextFirstIndent>By using this Website, you represent and
  warrant that you are of legal age to form a binding contract with the Company.
  If you do not meet all of the eligibility requirements, you must not access or
  use the Website.</p>
  
  <p class=MsoNormal style='margin-bottom:12.0pt;text-align:justify'><b><u>Changes
  to the Terms of Use</u></b></p>
  
  <p class=MsoBodyTextFirstIndent>We may revise and update these Terms of Use
  from time to time in our sole discretion. All changes are effective immediately
  when we post them, and apply to all access to and use of the Website
  thereafter. </p>
  
  <p class=MsoBodyTextFirstIndent>Your continued use of the Website following the
  posting of revised Terms of Use means that you accept and agree to the changes.
  You are expected to check this page so you are aware of any changes, because
  the changes are binding on you. </p>
  
  <p class=MsoNormal style='margin-bottom:12.0pt;text-align:justify'><b><u>Accessing
  the Website and Account Security</u></b></p>
  
  <p class=MsoBodyTextFirstIndent>We reserve the right to withdraw or amend this
  Website, and any service or material we provide on the Website, in our sole
  discretion without notice. We will not be liable if for any reason all or any
  part of the Website is unavailable at any time or for any period. From time to
  time, we may restrict user access to some parts of the Website, or the entire
  Website, including restrictions on access affecting registered users.</p>
  
  <p class=MsoBodyTextFirstIndent style='page-break-after:avoid'>You are
  responsible for:</p>
  
  <p class=MsoNormal style='margin-top:0in;margin-right:0in;margin-bottom:12.0pt;
  margin-left:1.0in;text-align:justify;text-indent:-.5in'><span style='font-family:
  Symbol'>·<span style='font:7.0pt "Times New Roman"'>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
  </span></span>Making all arrangements necessary for you to have access to the
  Website.</p>
  
  <p class=MsoNormal style='margin-top:0in;margin-right:0in;margin-bottom:12.0pt;
  margin-left:1.0in;text-align:justify;text-indent:-.5in'><span style='font-family:
  Symbol'>·<span style='font:7.0pt "Times New Roman"'>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
  </span></span>Ensuring that all persons who access the Website through your
  internet connection are aware of these Terms of Use and comply with them.</p>
  
  <p class=MsoBodyTextFirstIndent>To access the Website or the resources it
  offers, you may be asked to provide certain registration details or other
  information. It is a condition of your use of the Website that all the
  information you provide on the Website is correct, current and complete. You
  agree that all information you provide to register with this Website or
  otherwise, including through the use of any interactive features on the
  Website, is governed by our Privacy Policy
  [https://store.triblymusic.com/privacy-policy], and you consent to all actions
  we take with respect to your information consistent with our Privacy Policy.</p>
  
  <p class=MsoBodyTextFirstIndent>If you choose, or are provided with, a user
  name, password or any other piece of information as part of our security
  procedures, you must treat such information as confidential and you must not
  disclose it to any other person or entity. You also acknowledge that your
  account is personal to you and agree not to provide access to this Website, or
  portions of it, to any other person using your user name, password or other
  security information. You agree to notify us immediately of any unauthorized
  access to or use of your user name or password or any other breach of security.
  You also agree to ensure that you exit from your account at the end of each
  session. You should use particular caution when accessing your account from a
  public or shared computer so that others are not able to view or record your
  password or other personal information.</p>
  
  <p class=MsoBodyTextFirstIndent>We have the right to disable any user name,
  password or other identifier, whether chosen by you or provided by us, at any
  time in our sole discretion for any or no reason, including if, in our opinion,
  you have violated any provision of these Terms of Use.</p>
  
  <p class=MsoNormal style='margin-bottom:12.0pt;text-align:justify'><b><u>Intellectual
  Property Rights</u></b></p>
  
  <p class=MsoBodyTextFirstIndent>The Website and its entire contents, features
  and functionality (including but not limited to all information, software,
  text, displays, images, video and audio, and the design, selection and
  arrangement thereof), are owned by the Company, its licensors or other
  providers of such material and are protected by United States and international
  copyright, trademark, patent, trade secret and other intellectual property and
  proprietary rights laws.</p>
  
  <p class=MsoBodyTextFirstIndent>These Terms of Use permit you to use the
  Website <u>only</u> for your personal, non-commercial use. You may not
  reproduce, distribute, modify, create derivative works of or from, publicly
  display, publicly perform, republish, download, store, transmit, use for
  commercial purposes or charge third persons for access through your account to
  any of the material on our Website, except as follows:</p>
  
  <p class=MsoNormal style='margin-top:0in;margin-right:0in;margin-bottom:12.0pt;
  margin-left:1.0in;text-align:justify;text-indent:-.5in'><span style='font-family:
  Symbol'>·<span style='font:7.0pt "Times New Roman"'>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
  </span></span>Your computer may temporarily store copies of such materials in
  RAM incidental to your accessing and viewing those materials.</p>
  
  <p class=MsoNormal style='margin-top:0in;margin-right:0in;margin-bottom:12.0pt;
  margin-left:1.0in;text-align:justify;text-indent:-.5in'><span style='font-family:
  Symbol'>·<span style='font:7.0pt "Times New Roman"'>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
  </span></span>You may store files that are automatically cached by your Web
  browser for display enhancement purposes.</p>
  
  <p class=MsoNormal style='margin-top:0in;margin-right:0in;margin-bottom:12.0pt;
  margin-left:1.0in;text-align:justify;text-indent:-.5in'><span style='font-family:
  Symbol'>·<span style='font:7.0pt "Times New Roman"'>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
  </span></span>You may print or download one (1) copy of a reasonable number of
  pages of the Website for your own personal, non-commercial use and not for
  further reproduction, publication or distribution.</p>
  
  <p class=MsoNormal style='margin-top:0in;margin-right:0in;margin-bottom:12.0pt;
  margin-left:1.0in;text-align:justify;text-indent:-.5in'><span style='font-family:
  Symbol'>·<span style='font:7.0pt "Times New Roman"'>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
  </span></span>If we provide desktop, mobile or other applications for download,
  you may download a single copy to your computer or mobile device solely for
  your own personal, non-commercial use, <u>provided</u> you agree to be bound by
  our End User License Agreement for such applications, as applicable.</p>
  
  <p class=MsoNormal style='margin-top:0in;margin-right:0in;margin-bottom:12.0pt;
  margin-left:1.0in;text-align:justify;text-indent:-.5in'><span style='font-family:
  Symbol'>·<span style='font:7.0pt "Times New Roman"'>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
  </span></span>If we provide social media features with certain content, you may
  take such actions as are enabled by such features.</p>
  
  <p class=MsoBodyTextFirstIndent>You are not authorized to and may not:</p>
  
  <p class=MsoNormal style='margin-top:0in;margin-right:0in;margin-bottom:12.0pt;
  margin-left:1.0in;text-align:justify;text-indent:-.5in'><span style='font-family:
  Symbol'>·<span style='font:7.0pt "Times New Roman"'>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
  </span></span>Modify copies of any materials from this Website.</p>
  
  <p class=MsoNormal style='margin-top:0in;margin-right:0in;margin-bottom:12.0pt;
  margin-left:1.0in;text-align:justify;text-indent:-.5in'><span style='font-family:
  Symbol'>·<span style='font:7.0pt "Times New Roman"'>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
  </span></span>Use any illustrations, photographs, video or audio sequences or
  any graphics separately from the accompanying text or materials.</p>
  
  <p class=MsoNormal style='margin-top:0in;margin-right:0in;margin-bottom:12.0pt;
  margin-left:1.0in;text-align:justify;text-indent:-.5in'><span style='font-family:
  Symbol'>·<span style='font:7.0pt "Times New Roman"'>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
  </span></span>Delete or alter any copyright, trademark or other proprietary
  rights notices from copies of materials from this site.</p>
  
  <p class=MsoNormal style='margin-top:0in;margin-right:0in;margin-bottom:12.0pt;
  margin-left:1.0in;text-align:justify;text-indent:-.5in'><span style='font-family:
  Symbol'>·<span style='font:7.0pt "Times New Roman"'>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
  </span></span>Access or use for any commercial purposes any part of the Website
  or any services or materials available through the Website.</p>
  
  <p class=MsoBodyTextFirstIndent>The prohibitions set forth in the bullet-points
  above do not modify, supersede or limit any other statements of limited,
  restricted or prohibited use set forth elsewhere in these Terms of Use. </p>
  
  <p class=MsoBodyTextFirstIndent>If you print, copy, modify, download or
  otherwise use, or provide access to any part of the Website to any other person
  in breach of the Terms of Use, your right to use the Website will cease
  immediately and you must return or destroy, at our option, any copies,
  summaries, extracts and compilations of any Website materials you have made. No
  rights, title or interests in or to the Website, any content on the Website or
  any intellectual property Company owns or has rights to use in connection with
  or arising from the Website is transferred to you, and all rights not expressly
  granted to you are reserved by the Company. Any use of the Website not expressly
  permitted by these Terms of Use is a breach of these Terms of Use and may
  violate copyright, trademark and other laws.</p>
  
  <p class=MsoNormal style='margin-bottom:12.0pt;text-align:justify;page-break-after:
  avoid'><b><u>Trademarks</u></b></p>
  
  <p class=MsoBodyTextFirstIndent>The names Fan Space, LLC and Tribly, the
  Company logo and all related names, logos, product and service names, designs and
  slogans are trademarks of the Company or its affiliates or licensors. You must
  not use such marks without the prior written permission of the Company. All
  other names, logos, product and service names, designs and slogans on this
  Website are the trademarks of their respective owners.</p>
  
  <p class=MsoNormal style='margin-bottom:12.0pt;text-align:justify'><b><u>Prohibited
  Uses</u></b></p>
  
  <p class=MsoBodyTextFirstIndent>You may use the Website only for lawful
  purposes and in accordance with these Terms of Use. You agree not to use the
  Website:</p>
  
  <p class=MsoNormal style='margin-top:0in;margin-right:0in;margin-bottom:12.0pt;
  margin-left:1.0in;text-align:justify;text-indent:-.5in'><span style='font-family:
  Symbol'>·<span style='font:7.0pt "Times New Roman"'>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
  </span></span>In any way that violates any applicable federal, state, local or
  international law or regulation (including, without limitation, any laws
  regarding the export of data or software to and from the US or other
  countries). </p>
  
  <p class=MsoNormal style='margin-top:0in;margin-right:0in;margin-bottom:12.0pt;
  margin-left:1.0in;text-align:justify;text-indent:-.5in'><span style='font-family:
  Symbol'>·<span style='font:7.0pt "Times New Roman"'>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
  </span></span>For the purpose of exploiting, harming or attempting to exploit
  or harm minors in any way, including by exposing them to inappropriate content,
  asking for personally identifiable information or otherwise.</p>
  
  <p class=MsoNormal style='margin-top:0in;margin-right:0in;margin-bottom:12.0pt;
  margin-left:1.0in;text-align:justify;text-indent:-.5in'><span style='font-family:
  Symbol'>·<span style='font:7.0pt "Times New Roman"'>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
  </span></span>To send, knowingly receive, upload, download, use or re-use any
  material that does not comply with the Content Standards set out in these Terms
  of Use.</p>
  
  <p class=MsoNormal style='margin-top:0in;margin-right:0in;margin-bottom:12.0pt;
  margin-left:1.0in;text-align:justify;text-indent:-.5in'><span style='font-family:
  Symbol'>·<span style='font:7.0pt "Times New Roman"'>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
  </span></span>To transmit, or procure the sending of, any advertising or
  promotional material, including any &quot;junk mail,&quot; &quot;chain
  letter&quot; or &quot;spam&quot; or any other similar solicitation.</p>
  
  <p class=MsoNormal style='margin-top:0in;margin-right:0in;margin-bottom:12.0pt;
  margin-left:1.0in;text-align:justify;text-indent:-.5in'><span style='font-family:
  Symbol'>·<span style='font:7.0pt "Times New Roman"'>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
  </span></span>To impersonate or attempt to impersonate the Company, a Company
  employee, another user or any other person or entity (including by using e-mail
  addresses associated with any of the foregoing).</p>
  
  <p class=MsoNormal style='margin-top:0in;margin-right:0in;margin-bottom:12.0pt;
  margin-left:1.0in;text-align:justify;text-indent:-.5in'><span style='font-family:
  Symbol'>·<span style='font:7.0pt "Times New Roman"'>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
  </span></span>To engage in any other conduct that restricts or inhibits
  anyone's use or enjoyment of the Website, or which, as determined by us, may
  harm the Company or users of the Website or expose them to liability.</p>
  
  <p class=MsoBodyTextFirstIndent>Additionally, you agree not to:</p>
  
  <p class=MsoNormal style='margin-top:0in;margin-right:0in;margin-bottom:12.0pt;
  margin-left:1.0in;text-align:justify;text-indent:-.5in'><span style='font-family:
  Symbol'>·<span style='font:7.0pt "Times New Roman"'>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
  </span></span>Use the Website in any manner that could disable, overburden,
  damage, or impair the site or interfere with any other person's use of the
  Website, including their ability to engage in real time activities through the
  Website.</p>
  
  <p class=MsoNormal style='margin-top:0in;margin-right:0in;margin-bottom:12.0pt;
  margin-left:1.0in;text-align:justify;text-indent:-.5in'><span style='font-family:
  Symbol'>·<span style='font:7.0pt "Times New Roman"'>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
  </span></span>Use any robot, spider or other automatic device, process or means
  to access the Website for any purpose, including monitoring or copying any of
  the material on the Website.</p>
  
  <p class=MsoNormal style='margin-top:0in;margin-right:0in;margin-bottom:12.0pt;
  margin-left:1.0in;text-align:justify;text-indent:-.5in'><span style='font-family:
  Symbol'>·<span style='font:7.0pt "Times New Roman"'>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
  </span></span>Use any manual process to monitor or copy any of the material on
  the Website or for any other unauthorized purpose without our prior written
  consent.</p>
  
  <p class=MsoNormal style='margin-top:0in;margin-right:0in;margin-bottom:12.0pt;
  margin-left:1.0in;text-align:justify;text-indent:-.5in'><span style='font-family:
  Symbol'>·<span style='font:7.0pt "Times New Roman"'>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
  </span></span>Use any device, software or routine that interferes with the
  proper working of the Website.</p>
  
  <p class=MsoNormal style='margin-top:0in;margin-right:0in;margin-bottom:12.0pt;
  margin-left:1.0in;text-align:justify;text-indent:-.5in'><span style='font-family:
  Symbol'>·<span style='font:7.0pt "Times New Roman"'>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
  </span></span>Introduce into, on or through the Website any viruses, trojan
  horses, worms, logic bombs or other material that is malicious or
  technologically harmful.</p>
  
  <p class=MsoNormal style='margin-top:0in;margin-right:0in;margin-bottom:12.0pt;
  margin-left:1.0in;text-align:justify;text-indent:-.5in'><span style='font-family:
  Symbol'>·<span style='font:7.0pt "Times New Roman"'>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
  </span></span>Attempt to gain unauthorized access to, interfere with, damage or
  disrupt any parts of the Website, the server on which the Website is stored, or
  any server, computer or database connected to the Website. </p>
  
  <p class=MsoNormal style='margin-top:0in;margin-right:0in;margin-bottom:12.0pt;
  margin-left:1.0in;text-align:justify;text-indent:-.5in'><span style='font-family:
  Symbol'>·<span style='font:7.0pt "Times New Roman"'>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
  </span></span>Attack the Website via a denial-of-service attack or a
  distributed denial-of-service attack.</p>
  
  <p class=MsoNormal style='margin-top:0in;margin-right:0in;margin-bottom:12.0pt;
  margin-left:1.0in;text-align:justify;text-indent:-.5in'><span style='font-family:
  Symbol'>·<span style='font:7.0pt "Times New Roman"'>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
  </span></span>Otherwise attempt to interfere with the proper working of the
  Website.</p>
  
  <p class=MsoNormal style='margin-bottom:12.0pt;text-align:justify'><b><u>User
  Contributions</u></b></p>
  
  <p class=MsoBodyTextFirstIndent>The Website may contain message boards, chat
  rooms, personal web pages or profiles, forums, bulletin boards, and other
  interactive features (collectively, &quot;<b>Interactive Services</b>&quot;)
  that allow users to post, submit, contribute, publish, display or transmit to
  other users or other persons (all such actions, hereinafter, &quot;<b>post</b>&quot;)
  content or materials (collectively, &quot;<b>User Contributions</b>&quot;) on
  or through the Website.</p>
  
  <p class=MsoBodyTextFirstIndent>All User Contributions must comply with the
  Content Standards set out in these Terms of Use.</p>
  
  <p class=MsoBodyTextFirstIndent>Any User Contribution you post to the Website
  will be considered non-confidential and non-proprietary. By posting any User
  Contribution on the Website, you grant us and our affiliates and service
  providers, and each of their and our respective licensees, successors and
  assigns the irrevocable, unrestricted right to use, reproduce, modify, perform,
  display, distribute and otherwise disclose to third parties any such material
  for any purpose. </p>
  
  <p class=MsoBodyTextFirstIndent>You represent and warrant that: </p>
  
  <p class=MsoNormal style='margin-top:0in;margin-right:0in;margin-bottom:12.0pt;
  margin-left:1.0in;text-align:justify;text-indent:-.5in'><span style='font-family:
  Symbol'>·<span style='font:7.0pt "Times New Roman"'>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
  </span></span>You own or control all rights in and to the User Contributions
  you post on or to the Website, and you have the legal right to grant the
  license granted above to us and our affiliates and service providers, and each
  of their and our respective licensees, successors and assigns.</p>
  
  <p class=MsoNormal style='margin-top:0in;margin-right:0in;margin-bottom:12.0pt;
  margin-left:1.0in;text-align:justify;text-indent:-.5in'><span style='font-family:
  Symbol'>·<span style='font:7.0pt "Times New Roman"'>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
  </span></span>All of your User Contributions do and will comply with these
  Terms of Use. </p>
  
  <p class=MsoBodyTextFirstIndent>You understand and acknowledge that you are
  responsible for any User Contributions you post, and you, not the Company, have
  sole responsibility for any such User Contribution, including its legality,
  reliability, accuracy and appropriateness.</p>
  
  <p class=MsoBodyTextFirstIndent> We are not, and will not be, responsible or
  liable to any third party for the content or accuracy of any User Contributions
  posted by you or any other user of the Website, and you agree to defend, indemnify
  and hold harmless Company from all demands, claims, allegations, liabilities,
  actions, proceedings, causes of action and suits of every kind and character
  (&quot;<b>Claims</b>&quot;) and all losses, damages, awards, judgments, fines,
  penalties, expenses (including, without limitation, attorneys' fees), costs and
  other detriments (&quot;<b>Losses</b>&quot;) arising from or related to your
  User Contributions posted by you. </p>
  
  <p class=MsoNormal style='margin-bottom:12.0pt;text-align:justify'><b><u>Monitoring
  and Enforcement; Termination</u></b></p>
  
  <p class=MsoBodyTextFirstIndent>We have the right at any time and without
  notice to you to:</p>
  
  <p class=MsoNormal style='margin-top:0in;margin-right:0in;margin-bottom:12.0pt;
  margin-left:1.0in;text-align:justify;text-indent:-.5in'><span style='font-family:
  Symbol'>·<span style='font:7.0pt "Times New Roman"'>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
  </span></span>Remove or refuse to post any User Contributions, for any reason
  or no reason, in our sole discretion.</p>
  
  <p class=MsoNormal style='margin-top:0in;margin-right:0in;margin-bottom:12.0pt;
  margin-left:1.0in;text-align:justify;text-indent:-.5in'><span style='font-family:
  Symbol'>·<span style='font:7.0pt "Times New Roman"'>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
  </span></span>Take any action with respect to any User Contribution that we
  deem necessary or appropriate in our sole discretion, including if we believe
  that such User Contribution violates the Terms of Use (including the Content
  Standards), infringes any intellectual property right or other right of any
  person or entity, threatens the personal safety of users of the Website or the
  public or could create liability for the Company.</p>
  
  <p class=MsoNormal style='margin-top:0in;margin-right:0in;margin-bottom:12.0pt;
  margin-left:1.0in;text-align:justify;text-indent:-.5in'><span style='font-family:
  Symbol'>·<span style='font:7.0pt "Times New Roman"'>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
  </span></span>Disclose your identity or other information about you to any
  third party who claims that material posted by you violates their rights,
  including their intellectual property rights or their right to privacy.</p>
  
  <p class=MsoNormal style='margin-top:0in;margin-right:0in;margin-bottom:12.0pt;
  margin-left:1.0in;text-align:justify;text-indent:-.5in'><span style='font-family:
  Symbol'>·<span style='font:7.0pt "Times New Roman"'>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
  </span></span>Take appropriate legal action, including referral to law
  enforcement, for any illegal or unauthorized use of the Website. </p>
  
  <p class=MsoNormal style='margin-top:0in;margin-right:0in;margin-bottom:12.0pt;
  margin-left:1.0in;text-align:justify;text-indent:-.5in'><span style='font-family:
  Symbol'>·<span style='font:7.0pt "Times New Roman"'>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
  </span></span>Terminate or suspend your access to all or part of the Website
  for any or no reason, including for any violation of these Terms of Use.</p>
  
  <p class=MsoBodyTextFirstIndent>Without limiting the foregoing, we have the right
  to fully cooperate with any law enforcement authorities or court order
  requesting or directing us to disclose the identity or other information of
  anyone posting any materials on or through the Website. YOU HEREBY FOREVER
  WAIVE, AND RELEASE, DEFEND, INDEMNIFY AND HOLD HARMLESS THE COMPANY AND ITS
  AFFILIATES, LICENSEES AND SERVICE PROVIDERS, FROM ANY CLAIMS AND LOSSES
  RESULTING FROM ANY ACTION TAKEN BY ANY OF THE FOREGOING PARTIES DURING OR AS A
  RESULT OF ITS INVESTIGATIONS AND FROM ANY ACTIONS TAKEN AS A CONSEQUENCE OF
  INVESTIGATIONS BY EITHER SUCH PARTIES OR LAW ENFORCEMENT AUTHORITIES.</p>
  
  <p class=MsoBodyTextFirstIndent>We do not undertake to review all material
  before it is posted on the Website and cannot promise, ensure or guarantee
  prompt removal of objectionable material after it has been posted. Accordingly,
  we assume no liability for any action or inaction on our part regarding
  transmissions, communications or content provided by you, any user or a third
  party. We have no liability or responsibility to anyone for performance or nonperformance
  of the activities described in this paragraph. </p>
  
  <p class=MsoNormal style='margin-bottom:12.0pt;text-align:justify'><b><u>Content
  Standards</u></b></p>
  
  <p class=MsoBodyTextFirstIndent>These following content standards (&quot;<b>Content
  Standards</b>&quot;) apply to any and all User Contributions and all uses of
  Interactive Services. User Contributions must comply, in their entireties, with
  all applicable federal, state, local and international laws and regulations.
  Without limiting the foregoing, User Contributions must not:</p>
  
  <p class=MsoNormal style='margin-top:0in;margin-right:0in;margin-bottom:12.0pt;
  margin-left:1.0in;text-align:justify;text-indent:-.5in'><span style='font-family:
  Symbol'>·<span style='font:7.0pt "Times New Roman"'>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
  </span></span>Contain any material that is defamatory, obscene, indecent,
  abusive, offensive, harassing, violent, hateful, inflammatory or otherwise
  objectionable.</p>
  
  <p class=MsoNormal style='margin-top:0in;margin-right:0in;margin-bottom:12.0pt;
  margin-left:1.0in;text-align:justify;text-indent:-.5in'><span style='font-family:
  Symbol'>·<span style='font:7.0pt "Times New Roman"'>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
  </span></span>Promote sexually explicit or pornographic material, violence or
  discrimination based on race, sex, religion, nationality, disability, sexual
  orientation or age.</p>
  
  <p class=MsoNormal style='margin-top:0in;margin-right:0in;margin-bottom:12.0pt;
  margin-left:1.0in;text-align:justify;text-indent:-.5in'><span style='font-family:
  Symbol'>·<span style='font:7.0pt "Times New Roman"'>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
  </span></span>Infringe any patent, trademark, trade secret, copyright or other
  intellectual property or other rights of any other person.</p>
  
  <p class=MsoNormal style='margin-top:0in;margin-right:0in;margin-bottom:12.0pt;
  margin-left:1.0in;text-align:justify;text-indent:-.5in'><span style='font-family:
  Symbol'>·<span style='font:7.0pt "Times New Roman"'>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
  </span></span>Violate the legal rights (including the rights of publicity and
  privacy) of others or contain any material that could give rise to any civil or
  criminal liability under applicable laws or regulations or that otherwise may
  be in conflict with these Terms of Use and our Privacy Policy
  [https://store.triblymusic.com/privacy-policy].</p>
  
  <p class=MsoNormal style='margin-top:0in;margin-right:0in;margin-bottom:12.0pt;
  margin-left:1.0in;text-align:justify;text-indent:-.5in'><span style='font-family:
  Symbol'>·<span style='font:7.0pt "Times New Roman"'>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
  </span></span>Be likely to deceive any person.</p>
  
  <p class=MsoNormal style='margin-top:0in;margin-right:0in;margin-bottom:12.0pt;
  margin-left:1.0in;text-align:justify;text-indent:-.5in'><span style='font-family:
  Symbol'>·<span style='font:7.0pt "Times New Roman"'>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
  </span></span>Promote any illegal activity, or advocate, promote or assist any
  unlawful act.</p>
  
  <p class=MsoNormal style='margin-top:0in;margin-right:0in;margin-bottom:12.0pt;
  margin-left:1.0in;text-align:justify;text-indent:-.5in'><span style='font-family:
  Symbol'>·<span style='font:7.0pt "Times New Roman"'>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
  </span></span>Cause annoyance, inconvenience or needless anxiety or be likely
  to upset, embarrass, alarm, annoy or bully any other person.</p>
  
  <p class=MsoNormal style='margin-top:0in;margin-right:0in;margin-bottom:12.0pt;
  margin-left:1.0in;text-align:justify;text-indent:-.5in'><span style='font-family:
  Symbol'>·<span style='font:7.0pt "Times New Roman"'>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
  </span></span>Impersonate any person or misrepresent your identity or
  affiliation with any person or organization. </p>
  
  <p class=MsoNormal style='margin-top:0in;margin-right:0in;margin-bottom:12.0pt;
  margin-left:1.0in;text-align:justify;text-indent:-.5in'><span style='font-family:
  Symbol'>·<span style='font:7.0pt "Times New Roman"'>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
  </span></span>Involve commercial activities or sales, such as contests,
  sweepstakes and other sales promotions, barter or advertising.</p>
  
  <p class=MsoNormal style='margin-top:0in;margin-right:0in;margin-bottom:12.0pt;
  margin-left:1.0in;text-align:justify;text-indent:-.5in'><span style='font-family:
  Symbol'>·<span style='font:7.0pt "Times New Roman"'>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
  </span></span>Give the impression that they emanate from or are endorsed by us
  or any other person or entity if this is not the case.</p>
  
  <p class=MsoNormal style='margin-bottom:12.0pt;text-align:justify'><b><u>Reliance
  on Information Posted</u></b></p>
  
  <p class=MsoBodyTextFirstIndent>The information presented on or through the
  Website is made available solely for general information purposes. We do not
  warrant the accuracy, completeness or usefulness of this information. Any
  reliance you place on such information is strictly at your own risk. We
  disclaim all liability and responsibility arising from or relating to any
  reliance placed on such materials by you or any other visitor to the Website,
  or by anyone who may be informed of any of its contents.</p>
  
  <p class=MsoBodyTextFirstIndent>This Website includes content provided by third
  parties, including materials provided by other users, bloggers, third party
  licensors, syndicators, aggregators and/or reporting services. All statements
  and/or opinions expressed in these third party materials, and all third party
  articles, responses to questions and other content are solely the opinions and
  the responsibility of the person or entity providing those materials. Third
  party materials do not necessarily reflect the opinion of the Company. We are
  not responsible or liable to you or any third party for the content or accuracy
  of any materials on the Website provided by third parties.</p>
  
  <p class=MsoNormal style='margin-bottom:12.0pt;text-align:justify'><b><u>Changes
  to the Website</u></b></p>
  
  <p class=MsoBodyTextFirstIndent>We may update the content on this Website from
  time to time, but its content is not necessarily complete or up-to-date. Any of
  the material on the Website may be out of date at any given time, and we are
  under no obligation to update such material. </p>
  
  <p class=MsoNormal style='margin-bottom:12.0pt;text-align:justify'><b><u>Information
  About You and Your Visits to the Website</u></b></p>
  
  <p class=MsoBodyTextFirstIndent>All information we collect on this Website is
  subject to our Privacy Policy [https://store.triblymusic.com/privacy-policy].
  By using the Website, you consent to all actions taken by us with respect to
  your information in compliance with the Privacy Policy. </p>
  
  <p class=MsoNormal style='margin-bottom:12.0pt;text-align:justify'><b><u>Online
  Purchases and Other Terms and Conditions</u></b></p>
  
  <p class=MsoBodyTextFirstIndent>All purchases through our Website or other
  transactions for the sale of goods, services, or information formed through the
  Website or as a result of visits made by you to the Website are governed by our
  Terms of Sale [https://store.triblymusic.com/terms-of-sale], which are hereby incorporated
  into these Terms of Use.</p>
  
  <p class=MsoBodyTextFirstIndent>Additional terms and conditions may also apply
  to specific portions, services or features of the Website. All such additional
  terms and conditions are hereby incorporated by this reference into these Terms
  of Use.</p>
  
  <p class=MsoNormal style='margin-bottom:12.0pt;text-align:justify'><b><u>Linking
  to the Website and Social Media Features</u></b></p>
  
  <p class=MsoBodyTextFirstIndent>You may link to our homepage, provided you do
  so in a way that is fair and legal and does not damage our reputation or take
  advantage of it, but you must not establish a link in such a way as to suggest
  any form of association, approval or endorsement on our part.</p>
  
  <p class=MsoBodyTextFirstIndent>This Website may provide certain social media
  features that enable you to:</p>
  
  <p class=MsoNormal style='margin-top:0in;margin-right:0in;margin-bottom:12.0pt;
  margin-left:1.0in;text-align:justify;text-indent:-.5in'><span style='font-family:
  Symbol'>·<span style='font:7.0pt "Times New Roman"'>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
  </span></span>Link from your own or third-party websites to certain content on
  this Website.</p>
  
  <p class=MsoNormal style='margin-top:0in;margin-right:0in;margin-bottom:12.0pt;
  margin-left:1.0in;text-align:justify;text-indent:-.5in'><span style='font-family:
  Symbol'>·<span style='font:7.0pt "Times New Roman"'>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
  </span></span>Send e-mails or other communications with certain content, or
  links to certain content, on this Website.</p>
  
  <p class=MsoNormal style='margin-top:0in;margin-right:0in;margin-bottom:12.0pt;
  margin-left:1.0in;text-align:justify;text-indent:-.5in'><span style='font-family:
  Symbol'>·<span style='font:7.0pt "Times New Roman"'>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
  </span></span>Cause limited portions of content on this Website to be displayed
  or appear to be displayed on Your own or certain third-party websites.</p>
  
  <p class=MsoBodyTextFirstIndent>You may use these features solely with respect
  to the content with which they are displayed and otherwise in accordance with
  any additional terms and conditions we may provide with respect to such
  features. Subject to the foregoing, you must not:</p>
  
  <p class=MsoNormal style='margin-top:0in;margin-right:0in;margin-bottom:12.0pt;
  margin-left:1.0in;text-align:justify;text-indent:-.5in'><span style='font-family:
  Symbol'>·<span style='font:7.0pt "Times New Roman"'>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
  </span></span>Establish a link from any website that is not owned by you.</p>
  
  <p class=MsoNormal style='margin-top:0in;margin-right:0in;margin-bottom:12.0pt;
  margin-left:1.0in;text-align:justify;text-indent:-.5in'><span style='font-family:
  Symbol'>·<span style='font:7.0pt "Times New Roman"'>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
  </span></span>Cause the Website or portions of it to be displayed on, or appear
  to be displayed by (such as, for example, framing, deep linking or in-line
  linking) any other site.</p>
  
  <p class=MsoNormal style='margin-top:0in;margin-right:0in;margin-bottom:12.0pt;
  margin-left:1.0in;text-align:justify;text-indent:-.5in'><span style='font-family:
  Symbol'>·<span style='font:7.0pt "Times New Roman"'>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
  </span></span>Link to any part of the Website other than the homepage.</p>
  
  <p class=MsoNormal style='margin-top:0in;margin-right:0in;margin-bottom:12.0pt;
  margin-left:1.0in;text-align:justify;text-indent:-.5in'><span style='font-family:
  Symbol'>·<span style='font:7.0pt "Times New Roman"'>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
  </span></span>Otherwise take any action with respect to the materials on this
  Website that is inconsistent with these Terms of Use.</p>
  
  <p class=MsoBodyTextFirstIndent>The website from which you are linking, or on
  which you make certain content accessible, must comply in all respects with the
  Content Standards set out in these Terms of Use.</p>
  
  <p class=MsoBodyTextFirstIndent>You agree to cooperate with us in causing any
  unauthorized framing or linking immediately to cease. We reserve the right to
  withdraw linking permission without notice.</p>
  
  <p class=MsoBodyTextFirstIndent>We may disable all or any social media features
  and any links in our sole discretion at any time without notice. </p>
  
  <p class=MsoNormal style='margin-bottom:12.0pt;text-align:justify'><b><u>Links
  from the Website</u></b></p>
  
  <p class=MsoBodyTextFirstIndent>If the Website contains links to other sites
  and resources provided by third parties including links contained in
  advertisements such as banner advertisements and sponsored links, these links
  are provided for your convenience only. We have no control over the contents of
  the sites or resources to which the links are associated and accept no
  responsibility for them or for any Loss that may arise from your use of them.
  If you decide to access any of the third party websites linked to this Website,
  you do so entirely at your own risk and subject to the terms and conditions of
  use for such websites.</p>
  
  <p class=MsoNormal style='margin-bottom:12.0pt;text-align:justify'><b><u>Geographic
  Restrictions</u></b></p>
  
  <p class=MsoBodyTextFirstIndent>The owner of the Website is based in the State
  of Mississippi in the United States. We provide this Website for use only by
  persons located in the United States. We make no claims that the Website or any
  of its content is accessible or appropriate outside of the United States.
  Access to the Website may not be legal by certain persons or in certain
  countries. If you access the Website from outside the United States, you do so
  on your own initiative and at your own risk, and you are solely responsible for
  compliance with local laws with respect to such access.</p>
  
  <p class=MsoNormal style='margin-bottom:12.0pt;text-align:justify;page-break-after:
  avoid'><b><u>Disclaimer of Warranties</u></b></p>
  
  <p class=MsoBodyTextFirstIndent>You understand that we cannot and do not
  guarantee or warrant that files available for downloading from the Internet or
  the Website will be free of viruses or other destructive code. You are
  responsible for implementing sufficient procedures and checkpoints to satisfy
  your particular requirements for anti-virus protection and accuracy of data
  input and output and for maintaining a means external to our site for any
  reconstruction of any lost data. WE WILL NOT BE LIABLE FOR ANY CLAIMS OR LOSSES
  CAUSED BY A DISTRIBUTED DENIAL-OF-SERVICE ATTACK, VIRUSES OR OTHER
  TECHNOLOGICALLY HARMFUL MATERIAL THAT MAY INFECT YOUR COMPUTER EQUIPMENT,
  COMPUTER PROGRAMS, DATA OR OTHER PROPRIETARY MATERIAL DUE TO YOUR USE OF THE
  WEBSITE OR ANY SERVICES OR ITEMS OBTAINED THROUGH THE WEBSITE, OR TO YOUR
  DOWNLOADING OF ANY MATERIAL POSTED ON THE WEBSITE, OR ON ANY WEBSITE LINKED TO
  THE WEBSITE.</p>
  
  <p class=MsoBodyTextFirstIndent>YOUR USE OF THE WEBSITE, ITS CONTENT AND ANY
  SERVICES OR MATERIALS OBTAINED THROUGH THE WEBSITE IS AT YOUR OWN RISK. THE
  WEBSITE, ITS CONTENT AND ANY SERVICES OR MATERIALS OBTAINED THROUGH THE WEBSITE
  ARE PROVIDED ON AN &quot;AS IS&quot; AND &quot;AS AVAILABLE&quot; BASIS,
  WITHOUT ANY WARRANTIES OF ANY KIND, EITHER EXPRESS OR IMPLIED. NEITHER THE
  COMPANY NOR ANY PERSON ASSOCIATED WITH THE COMPANY MAKES ANY WARRANTY OR REPRESENTATION
  WITH RESPECT TO THE COMPLETENESS, SECURITY, RELIABILITY, QUALITY, ACCURACY OR
  AVAILABILITY OF THE WEBSITE. WITHOUT LIMITING THE FOREGOING, NEITHER THE
  COMPANY NOR ANYONE ASSOCIATED WITH THE COMPANY REPRESENTS OR WARRANTS THAT THE
  WEBSITE, ITS CONTENT OR ANY SERVICES OR MATERIALS OBTAINED THROUGH THE WEBSITE
  WILL BE ACCURATE, RELIABLE, ERROR-FREE OR UNINTERRUPTED, THAT DEFECTS WILL BE
  CORRECTED, THAT THE WEBSITE OR THE SERVER THAT MAKES IT AVAILABLE ARE FREE OF
  VIRUSES OR OTHER HARMFUL COMPONENTS OR THAT THE WEBSITE OR ANY SERVICES OR
  MATERIALS OBTAINED THROUGH THE WEBSITE WILL OTHERWISE MEET YOUR NEEDS OR
  EXPECTATIONS. </p>
  
  <p class=MsoBodyTextFirstIndent>THE COMPANY HEREBY DISCLAIMS ALL WARRANTIES OF
  ANY KIND, WHETHER EXPRESS OR IMPLIED, STATUTORY OR OTHERWISE, INCLUDING ANY
  WARRANTIES OF MERCHANTABILITY, NON-INFRINGEMENT AND FITNESS FOR A PARTICULAR
  PURPOSE.</p>
  
  <p class=MsoBodyTextFirstIndent>THE FOREGOING DISCLAIMER OR WARRANTIES DOES NOT
  AFFECT ANY WARRANTIES THAT CANNOT BE EXCLUDED OR LIMITED UNDER APPLICABLE LAW.</p>
  
  <p class=MsoNormal style='margin-bottom:12.0pt;text-align:justify'><b><u>Limitation
  on Liability</u></b></p>
  
  <p class=MsoBodyTextFirstIndent>IN NO EVENT WILL THE COMPANY, ITS AFFILIATES OR
  THEIR LICENSORS, SERVICE PROVIDERS, EMPLOYEES, CONTRACTORS, AGENTS,
  REPRESENTATIVES, OFFICERS OR DIRECTORS BE LIABLE FOR CLAIMS OR LOSSES OF ANY
  KIND, UNDER ANY LEGAL THEORY, ARISING OUT OF OR IN CONNECTION WITH YOUR USE, OR
  INABILITY TO USE, THE WEBSITE, ANY WEBSITES LINKED TO IT, ANY CONTENT ON THE
  WEBSITE OR SUCH OTHER WEBSITES OR ANY SERVICES OR MATERIALS OBTAINED THROUGH
  THE WEBSITE OR SUCH OTHER WEBSITES, INCLUDING ANY DIRECT, INDIRECT, SPECIAL,
  INCIDENTAL, CONSEQUENTIAL OR PUNITIVE DAMAGES, WHICH MAY INCLUDE PERSONAL
  INJURY, PAIN AND SUFFERING, EMOTIONAL DISTRESS, LOSS OF REVENUE, LOSS OF
  PROFITS, LOSS OF BUSINESS OR ANTICIPATED SAVINGS, LOSS OF USE, LOSS OF GOODWILL
  OR LOSS OF DATA, WHETHER SUCH CLAIMS, LOSSES OR OTHER DAMAGES WERE CAUSED BY
  TORT (INCLUDING NEGLIGENCE), BREACH OF CONTRACT OR OTHERWISE, EVEN IF
  FORESEEABLE.</p>
  
  <p class=MsoBodyTextFirstIndent>THE FOREGOING DISCLAIMER OF LIABILITY DOES NOT
  AFFECT ANY LIABILITY THAT CANNOT BE EXCLUDED OR LIMITED UNDER APPLICABLE LAW.</p>
  
  <p class=MsoNormal style='margin-bottom:12.0pt;text-align:justify'><b><u>Indemnification</u></b></p>
  
  <p class=MsoBodyTextFirstIndent><span style='text-transform:uppercase'>You
  agree to RELEASE, defend, indemnify and hold harmless the Company, its
  affiliates, LICENSORS and service providers, and its and their respective
  officers, directors, employees, contractors, agents, REPRESENTATIVES,
  licensors, suppliers, successors and assigns, from and against ALL claims and
  losses arising out of or relating to Your violation of these Terms of Use or
  Your use of the Website, including Your User Contributions, any use of the
  Website's content, services and products other than as expressly authorized in
  these Terms of Use or Your use of any information obtained from the Website.</span></p>
  
  <p class=MsoNormal style='margin-bottom:12.0pt;text-align:justify'><b><u>Governing
  Law and Jurisdiction</u></b></p>
  
  <p class=MsoBodyTextFirstIndent>All matters relating to the Website and these
  Terms of Use and any dispute or Claim or Losses arising therefrom or related
  thereto (in each case, including non-contractual disputes or Claims), shall be
  governed by and construed in accordance with the internal laws of the State of
  Mississippi without giving effect to any choice or conflict of law provision or
  rule (whether of the State of Mississippi or any other jurisdiction).</p>
  
  <p class=MsoBodyTextFirstIndent>Any Claim arising out of, or related to, these
  Terms of Use or the Website shall be instituted exclusively in the federal
  courts of the United States or the courts of the State of Mississippi in each
  case located in the City of Brandon and County of Rankin although we retain the
  right to bring any Claim or proceeding against you for breach of these Terms of
  Use in your state or country of residence or any other relevant state or
  country in which you can be reached by legal process. You waive any and all
  objections to the exercise of jurisdiction over you by such courts or tribunals
  and to venue in such courts or tribunals, including the objection of
  inconvenient forum.</p>
  
  <p class=MsoNormal style='margin-bottom:12.0pt;text-align:justify'><b><u>Waiver
  and Severability</u></b></p>
  
  <p class=MsoBodyTextFirstIndent>No waiver by the Company of any term or condition
  set forth in these Terms of Use shall be deemed a further or continuing waiver
  of such term or condition or a waiver of any other term or condition herein,
  and any failure of the Company to assert a right or provision under these Terms
  of Use shall not constitute a waiver of such right or provision.</p>
  
  <p class=MsoBodyTextFirstIndent>If any provision of these Terms of Use is held
  by a court or other tribunal of competent jurisdiction to be invalid, illegal
  or unenforceable for any reason, such provision shall be eliminated or limited
  to the minimum extent such that the remaining provisions of the Terms of Use
  will continue in full force and effect. </p>
  
  <p class=MsoNormal style='margin-bottom:12.0pt;text-align:justify'><b><u>Interpretation</u></b></p>
  
  <p class=MsoBodyTextFirstIndent>For purposes of these Terms of Use, (a) the
  words &quot;include,&quot; &quot;includes&quot; and &quot;including&quot; shall
  be deemed to be followed by the words &quot;without limitation&quot;; (b) the
  word &quot;or&quot; is not exclusive; and (c) the words &quot;herein,&quot;
  &quot;hereof,&quot; &quot;hereby,&quot; &quot;hereto&quot; and
  &quot;hereunder&quot; refer to these Terms of Use as a whole. Unless the
  context otherwise requires, references herein: (i) to articles, sections,
  exhibits, schedules or attachments refer to the articles, sections, exhibits,
  schedules or attachments to or attached to, these Terms of Use; (ii) to an
  agreement, instrument or other document means such agreement, instrument or
  other document as amended, supplemented and modified from time to time to the
  extent permitted by the provisions thereof; and (iii) to a Law means such Law
  as amended from time to time and includes any successor legislation thereto and
  any regulations promulgated thereunder. These Terms of Use shall be construed
  without regard to any presumption or rule requiring construction or
  interpretation against the party drafting an instrument or causing any
  instrument to be drafted. Any exhibits, schedules or attachments referred to
  herein shall be construed with, and as an integral part of, these Terms of Use
  to the same extent as if they were set forth verbatim herein.</p>
  
  <p class=MsoNormal style='margin-bottom:12.0pt;text-align:justify'><b><u>Entire
  Agreement</u></b></p>
  
  <p class=MsoBodyTextFirstIndent>The Terms of Use, our Privacy Policy, and Terms
  of Sale constitute the sole and entire agreement between you and Fan Space, LLC
  d/b/a Tribly with respect to your access to or use of the Website and supersede
  all prior and contemporaneous understandings, agreements, representations and
  warranties, both written and oral, with respect to the Website. </p>
  
  <p class=MsoNormal style='margin-bottom:12.0pt;text-align:justify'><b><u>Your
  Comments and Concerns</u></b></p>
  
  <p class=MsoBodyTextFirstIndent>This Website is operated by Fan Space, LLC
  d/b/a Tribly at 10 Canebrake Blvd. Suite 110, Flowood, MS 39232.</p>
  
  <p class=MsoBodyTextFirstIndent>All other feedback, comments, requests for
  technical support and other communications relating to the Website should be directed
  to: support@triblymusic.com</p>
  
  </div>`

  return (
    <Layout title="Collections">
      <Box css={PrivacyPolicyPageStyle.FeaturedBoxStyle}>
        <Typography variant="h1">Terms of use</Typography>
      </Box>
      <Divider />

      <Container sx={{ padding: 4, color: "white" }}>
        <Box dangerouslySetInnerHTML={{ __html: html }}></Box>
      </Container>
    </Layout>
  )
}

export default PrivacyPolicyPage
